import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { TournamentType } from 'src/replicant/match2/tournament/match2-tournament.ruleset';
import { getTournamentIconImage } from './match2-tournament.utils';

export type Match2TournamentScoreParams = {
  score: number;
};

export class Match2TournamentScore extends View {
  private readonly score: LangBitmapFontTextView;
  private readonly scoreBg: ImageScaleView;
  private readonly scoreIcon: ImageScaleView;

  constructor(opts: ViewOpts, type: TournamentType = 'star') {
    super({
      width: 80,
      height: 80,
      ...opts,
    });

    this.scoreBg = new ImageScaleView({
      superview: this,
      x: 55,
      y: this.style.height * 0.5 + 2,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      align: 'center',
      verticalAlign: 'center',
      width: 117,
      height: 42,
      image: 'assets/ui/match2/tournament/star_tournament_score_bg.png',
    });

    this.score = new LangBitmapFontTextView({
      superview: this,
      x: 15,
      y: 0,
      align: 'right',
      verticalAlign: 'center',
      size: 26,
      font: 'Title',
      width: 80,
      height: this.style.height,
    });

    this.scoreIcon = new ImageScaleView({
      superview: this,
      x: 0,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      align: 'center',
      verticalAlign: 'center',
      width: 44,
      height: 44,
      image: getTournamentIconImage(type),
    });
  }

  public setup(params: Match2TournamentScoreParams) {
    this.score.localeText = () => `${params.score}`;
  }
}
